import React, { Component } from 'react';
import { TitleHeading } from './UIElements/headings/TitleHeading';
import { ButtonStyle } from './UIElements/Buttons/ButtonStyle';
import ReCAPTCHA from "react-google-recaptcha";
import Popup from "reactjs-popup";
import { connect } from 'react-redux';
import { geolocated } from "react-geolocated";
import axios from 'axios'
import SetAdvertiseLocation from './SetAdvertiseLocation';
import Loader from './utility/Loader';
import { notifyUser, type } from './utility/notifyUser';
import authservice from './Authentication/service/authservice';
import { validEmailRegex, usernameRegex, validateForm } from './RegxConst'

class ChangeLocationPopUp extends Component {

    constructor(props) {
        super(props);
        // this.openModal = this.openModal.bind(this);
        // this.closeModal = this.closeModal.bind(this);
        this.addressOptions = [];
        this.selectedNeighbourhood = [];
        this.selectedLocality = [];
        this.selectedCity = [];
        this.selectedState = [];
        this.stateValidation = null;
        this.cityValidation = null;
        this.localityValidation = null;
        this.neighbourhoodValidation = null;
        this.hasGetStateBeenCalled = false
    }
    state = {
        open: true,
        closeButton: false,
        selectedNeighbourhood: [],
        selectedLocality: [],
        selectedCity: [],
        selectedState: [],
        fullAddress: [],
        name: "",
        email_address: "",
        subject: "",
        message: "",
        state: "",
        city: "",
        locality: "",
        neighbourhood: "",
        errors: {
            name: '',
            email_address: '',
            subject: '',
            message: '',
        },
        isVerified: '',
        captchaInvalid: ''
    };

    componentDidUpdate() {
        window.scrollTo(0, 0)
        if(this.props.open && !this.hasGetStateBeenCalled) {
            this.getState()
            this.hasGetStateBeenCalled = true;
        }
    }

    onChange = value => {
        if (value != '') {
            this.setState({ isVerified: 'success', captchaInvalid: '' })
        }
    }

    recaptchaRef = React.createRef();
    contactInfo = (event) => {
        event.preventDefault();

        let states = []
        this.selectedState.map(data => {
            states.push(data.label)
        })
        let cities = []
        this.selectedCity.map(data => {
            cities.push(data.label)
        })
        let localities = []
        this.selectedLocality.map(data => {
            localities.push(data.label)
        })
        let neighbourhoods = []
        this.selectedNeighbourhood.map(data => {
            neighbourhoods.push(data.label)
        })

        const data = {
            userName: authservice.getCurrentUserName(),
            email: authservice.getEmail(),
            subject: "Change Location",
            message: this.state.message,
            state: states[0],
            city: cities[0],
            locality: localities[0],
            neighbourhood: neighbourhoods[0]
        }

        if (validateForm(this.state.errors) && this.state.isVerified === 'success') {
            let dataVerified = true;
            if (this.selectedState.length < 1) {
                dataVerified = false
                notifyUser("Location", "Select Any State", type.DANGER)
            }  else if (this.cityValidation) {
                if (this.selectedCity.length < 1) {
                    dataVerified = false
                    notifyUser("Location", "Select Any City", type.DANGER)
                } else if (this.localityValidation) {
                    if (this.selectedLocality.length < 1) {
                        dataVerified = false
                        notifyUser("Location", "Select Any Locality", type.DANGER)
                    } else if (this.neighbourhoodValidation) {
                        if (this.selectedNeighbourhood.length < 1) {
                            dataVerified = false
                            notifyUser("Location", "Select Any Neighbourhood", type.DANGER)
                        }
                    }
                }
            }
            if (dataVerified) {
                axios.post(process.env.REACT_APP_BACKEND_URL + '/abmgr/support/request-support  ', data).then(response => {
                    if (response.status == 200) {
                        notifyUser("Location", "Your Change Location Request Email has been submitted, We will get back to you soon", type.INFO)
                        this.props.closeModal()
                        this.setState({ flag: response.data })
                    } else
                        throw Error("Something went wrong, please try again");
                }).catch(error => {
                    notifyUser("Location", error, type.DANGER)
                    console.log(error, 'Contact Us Service Failed');
                })
            }

        } else {
            this.setState({ captchaInvalid: 'please verify reCaptcha' })
        }
    }

    componentDidMount() {
        this.props.notifyPopupOpen(true)
    }

    getState = () => {
        Promise.all([
            axios.get(process.env.REACT_APP_BACKEND_URL + '/hpmgr/listing/getallstates'),
        ]).then(([getFullAddress]) => { // use arrow function to avoid loosing context, BTW you don't need to use axios.spread with ES2015 destructuring
            this.setState({ fullAddress: getFullAddress.data });
            this.props.fullAddress(getFullAddress.data)
            Loader.stopSpinner()
        }).catch(error => {
            Loader.stopSpinner()
            console.log(error, 'getting data failed');
        });
    }

    _handleState = (selectedStates) => {
        if (selectedStates.length)
            this.selectedState = selectedStates;
        else
            this.selectedState = [];
    }

    _handleCity = (e) => {
        if (e.length)
            this.selectedCity = e;
        else
            this.selectedCity = [];
    }
    _handleLocality = (e) => {
        if (e.length)
            this.selectedLocality = e;
        else
            this.selectedLocality = [];
    }
    _handleNeighbourhood = (e) => {
        if (e.length)
            this.selectedNeighbourhood = e
        else
            this.selectedNeighbourhood = [];
    }

    setAddressOptions = (options) => {
        this.addressOptions = options
    }

    setStateValidationMethod = (m) => {
        this.stateValidation = m;
    }

    setCityValidationMethod = (m) => {
        this.cityValidation = m;
    }

    setLocalityValidationMethod = (m) => {
        this.localityValidation = m;
    }

    setNeighbourhoodValidationMethod = (m) => {
        this.neighbourhoodValidation = m;
    }

    closeModal = () => {
        this.props.closeModal();
    }

    openModal = () => {

    }

    render() {
        const { errors } = this.state;
        return (
            <>
            <div className="col-md-12 billBoard" key={'popup-window'}>
                <Popup
                    open={this.props.open}
                    onClose={this.closeModal}
                    className="report_popup"
                    lockScroll={true}
                    overlayStyle={{ background: 'rgba(0,0,0,0.95)' }}
                    contentStyle={{ color: 'black' }}
                >
                    <div className="modal">
                        <a className="close" onClick={this.closeModal}> &times; </a>
                        <div className="contact_maincontent">
                            <TitleHeading text={'Change Location Request:'} />
                            <div className="contact_form">
                                <form className="" onSubmit={event => { this.contactInfo(event) }}>
                                    <div className="form-group row">
                                        <div className="col-sm-2"></div>
                                        <div className="col-sm-1 contact_content text-left">
                                            <label htmlFor="title" className="contact_label">Name:</label>
                                        </div>
                                        <div className="col-sm-6">
                                            <input type="text" className="form-control" placeholder="Name *" name="name" required
                                                value={authservice.getCurrentUserName()} id="username" readOnly noValidate />
                                        </div>
                                        <div className="col-sm-3"></div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-2"></div>
                                        <div className="col-sm-1 contact_content">
                                            <label htmlFor="title" className="contact_label">Email:</label>
                                        </div>
                                        <div className="col-sm-6">
                                            <input className="form-control" placeholder="Email *" name="email_address" required
                                                id="email" value={authservice.getEmail()} readOnly noValidate />
                                        </div>
                                        <div className="col-sm-3"></div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-2"></div>
                                        <div className="col-sm-1 contact_content">
                                            <label htmlFor="title" className="contact_label">Subject:</label>
                                        </div>
                                        <div className="col-sm-6">
                                            <input type="text" className="form-control" placeholder="Subject *"
                                                id="subject" readOnly value={"Change Location"} />
                                        </div>
                                        <div className="col-sm-3"></div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-2"></div>
                                        <div className="col-sm-1 contact_content">
                                            <label htmlFor="title" className="contact_label">State:</label>
                                            {this.cityValidation ? this.selectedCity.length > 1 ? <label htmlFor="title" className="contact_label">City:</label> : null : null}
                                        </div>

                                        <div className="col-sm-6">
                                            <SetAdvertiseLocation
                                                //heading='Areas Served' isMulti
                                                setFilterValidationMethod={this.setLocationValidationMethod}
                                                allLocations={this.state.fullAddress}
                                                selectedStates={this.state.selectedState}
                                                selectedCities={this.state.selectedCity}
                                                selectedLocalities={this.state.selectedLocality}
                                                selectedNeighbourhoods={this.state.selectedNeighbourhood}
                                                _handleState={this._handleState}
                                                _handleCity={this._handleCity}
                                                _handleLocality={this._handleLocality}
                                                _handleNeighbourhood={this._handleNeighbourhood}
                                                addressOptions
                                                setAddressOptions={this.setAddressOptions}
                                                labelClass={'col-md-2'}
                                                setStateValidationMethod={this.setStateValidationMethod}
                                                setCityValidationMethod={this.setCityValidationMethod}
                                                setLocalityValidationMethod={this.setLocalityValidationMethod}
                                                setNeighbourhoodValidationMethod={this.setNeighbourhoodValidationMethod}
                                            />
                                        </div>
                                        <div className="col-sm-3"></div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-2"></div>
                                        <div className="col-sm-1 contact_content">
                                            <label htmlFor="title" className="contact_label">Reason to Change:</label>
                                        </div>
                                        <div className="col-sm-6">
                                            <textarea className="form-control" placeholder="Message *" rows="5" id="message" required
                                                onChange={event => { this.setState({ message: event.target.value }) }}></textarea>
                                        </div>
                                        <div className="col-sm-3"></div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-3"></div>
                                        <div className="col-sm-6">
                                            <p className='location_p'>(If your location is not available, Please select your nearest location.)</p>
                                        </div>
                                        <div className="col-sm-3"></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-1"></div>
                                        <div className="col-sm-2"></div>
                                        <div className="col-sm-6">
                                            <span className='error'>{this.state.captchaInvalid}</span>
                                            <ReCAPTCHA
                                                //stoken
                                                ref={this.recaptchaRef}
                                                onChange={this.onChange}
                                                sitekey="6LfiH78UAAAAAESBlQa8G0s-AUEoKo3KPLqxey3D"
                                            />
                                        </div>
                                        <div className="col-sm-1"></div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-6"></div>
                                        <div className="col-sm-3 btn_sendmail text-right">
                                            <ButtonStyle type="submit" className="btn">Send Email</ButtonStyle>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </Popup>
            </div>
            <div className="large_rect" key={'popup-window'}>
                <Popup
                    open={this.props.open}
                    onClose={this.closeModal}
                    className="report_popup"
                    lockScroll={true}
                    overlayStyle={{ background: 'rgba(0,0,0,0.95)'}}
                    contentStyle={{ color: 'black', width:'360px', height:'500px', overflow:'scroll', scrollY: 'scroll' }}
                >
                    <div className="row col-md-12 modal">
                        <a className="close" onClick={this.closeModal}> &times; </a>
                        <div className="contact_maincontent">
                            <TitleHeading text={'Change Location Request:'} />
                            <div className="contact_form">
                                <form className="" onSubmit={event => { this.contactInfo(event) }}>
                                    <div className="form-group row">
                                        <div className="col-sm-2"></div>
                                        <div className="col-sm-1 contact_content text-left">
                                            <label htmlFor="title" className="contact_label">Name:</label>
                                        </div>
                                        <div className="col-sm-6">
                                            <input type="text" className="form-control" placeholder="Name *" name="name" required
                                                value={authservice.getCurrentUserName()} id="username" readOnly noValidate />
                                        </div>
                                        <div className="col-sm-3"></div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-2"></div>
                                        <div className="col-sm-1 contact_content text-left">
                                            <label htmlFor="title" className="contact_label">Email:</label>
                                        </div>
                                        <div className="col-sm-6">
                                            <input className="form-control" placeholder="Email *" name="email_address" required
                                                id="email" value={authservice.getEmail()} readOnly noValidate />
                                        </div>
                                        <div className="col-sm-3"></div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-2"></div>
                                        <div className="col-sm-1 contact_content text-left">
                                            <label htmlFor="title" className="contact_label">Subject:</label>
                                        </div>
                                        <div className="col-sm-6">
                                            <input type="text" className="form-control" placeholder="Subject *"
                                                id="subject" readOnly value={"Change Location"} />
                                        </div>
                                        <div className="col-sm-3"></div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-2"></div>
                                        <div className="col-sm-1 contact_content text-left">
                                            <label htmlFor="title" className="contact_label">State:</label>
                                        </div>

                                        <div className="col-sm-6">
                                            <SetAdvertiseLocation
                                                //heading='Areas Served' isMulti
                                                setFilterValidationMethod={this.setLocationValidationMethod}
                                                allLocations={this.state.fullAddress}
                                                selectedStates={this.state.selectedState}
                                                selectedCities={this.state.selectedCity}
                                                selectedLocalities={this.state.selectedLocality}
                                                selectedNeighbourhoods={this.state.selectedNeighbourhood}
                                                _handleState={this._handleState}
                                                _handleCity={this._handleCity}
                                                _handleLocality={this._handleLocality}
                                                _handleNeighbourhood={this._handleNeighbourhood}
                                                addressOptions
                                                setAddressOptions={this.setAddressOptions}
                                                labelClass={'col-md-2'}
                                                setStateValidationMethod={this.setStateValidationMethod}
                                                setCityValidationMethod={this.setCityValidationMethod}
                                                setLocalityValidationMethod={this.setLocalityValidationMethod}
                                                setNeighbourhoodValidationMethod={this.setNeighbourhoodValidationMethod}
                                            />
                                        </div>
                                        <div className="col-sm-3"></div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-2"></div>
                                        <div className="col-sm-1 contact_content text-left">
                                            <label htmlFor="title" className="contact_label">Reason to Change:</label>
                                        </div>
                                        <div className="col-sm-6">
                                            <textarea className="form-control" placeholder="Message *" rows="5" id="message" required
                                                onChange={event => { this.setState({ message: event.target.value }) }}></textarea>
                                        </div>
                                        <div className="col-sm-3"></div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-3"></div>
                                        <div className="col-sm-6">
                                            <p className='location_p'>(If your location is not available, Please select your nearest location.)</p>
                                        </div>
                                        <div className="col-sm-3"></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <span className='error'>{this.state.captchaInvalid}</span>
                                            <ReCAPTCHA
                                                //stoken
                                                ref={this.recaptchaRef}
                                                onChange={this.onChange}
                                                sitekey="6LfiH78UAAAAAESBlQa8G0s-AUEoKo3KPLqxey3D"
                                            />
                                        </div>
                                        <div className="col-sm-1"></div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-6"></div>
                                        <div className="col-sm-3 btn_sendmail text-right">
                                            <ButtonStyle type="submit" className="btn">Send Email</ButtonStyle>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </Popup>
            </div>
            </>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        //sendData: (bodyData) => dispatch({ type: 'SEND_DATA', post_data: bodyData }),
        notifyPopupOpen: (isPopupOpen) => dispatch({ type: 'POPUP_OPEN_NOTIFICATION', isPopupOpen: isPopupOpen }),
        fullAddress: (fulladdress) => dispatch({ type: "full_address", full_address: fulladdress }),
        setAddress: (setAdr) => dispatch({ type: "set_address", set_address: setAdr }),
        clearPropsData: () => dispatch({ type: 'CLEAR_DATA' })

    }
}

export default (connect(null, mapDispatchToProps)(ChangeLocationPopUp));